export const ANONYM_USER_IMG = 'https://ae-happines-zoho-images-storage.s3.us-east-2.amazonaws.com/anonymUser.png';
